<template>
  <div class="contentLoader">
    <v-progress-circular
      indeterminate
      color="primary"
      size="80"
      width="10"
    ></v-progress-circular>
  </div>
</template>

<script>
export default {
  name: 'ContentLoader',
  props: {},
  data: () => {
    return {}
  },
  methods: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {}
}
</script>

<style lang="scss" scoped>
.contentLoader {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
  padding-bottom: 100px;
}
</style>
